import { CommentViewItem } from '../LentaPage/components/CommentView/CommentViewItem'
import styles from './ProfilePage.module.css'
import backButton from './../../image/ic_back_button.png'
import { useNavigate } from 'react-router-dom'
import { NotificationDomain } from '../../models/commonModels'
import { useAppSelector } from '../../hooks/redux'
import { Avatar } from 'antd'
export const NotificationView = () =>{
    const c = ["1","1","1","1","1","1","1","1","1","1","1","1","1","1","1"]
    const notification:NotificationDomain[]|null = useAppSelector(state=>state.profileStore.notification)
    const regex = "/\p{Extended_Pictographic}/ug"
    const navigation = useNavigate();
    var emoji_regex = /^(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|[\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|[\ud83c[\ude32-\ude3a]|[\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])+$/;

    const emo_test = ({str}:{str:string}):boolean => {
        return emoji_regex.test(str)
    };
    return(
        <div className={styles.notificaton_container}>
            <div className={styles.notificaton_title_content}>
                <span onClick={()=>{navigation(-1)}} style={{cursor:"pointer"}}>
                        <img src={backButton}/>
                </span>
                <div className={styles.notificaton_title}>Уведомления</div>
            </div>
            {notification==null?<div></div>:notification.length==0?<div style={{display:"flex",flexDirection:"column" ,alignItems:"center"}}>Пока нет реакций и комментариев</div>:
            <div className={styles.notificaton_conent}>
                {notification.map(item=>{
                    return <div className={styles.notificaton_item_container}>
                        <Avatar size={32} icon={<img src={"https://sportsrestaurant.online"+item.photo}/>} />
                            <div className={styles.notification_data_container}>
                                    <div className={styles.notification_data_content}>
                                        <div style={{flex:"1"}}>
                                            <div className={styles.notification_fio}>{item.user_name}</div>
                                            <div className={styles.notification_date}>{"оценил(а) тренировку от " + item.activity_day}</div>
                                        </div>
                                        <div style={{width:"25px", textAlign:"center"}}>
                                            {emoji_regex.test(item.text)==true&&<div style={{fontSize:"18px"}}>{item.text}</div>}
                                        </div>
                                    </div>
                                    {emoji_regex.test(item.text)==false&&<div className={styles.notofication_comment}>
                                        {item.text}
                                    </div>}
                            </div>
                        </div> 
                })}
            </div>
            }
        </div>
    )
}